// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"f790074a","227":"521c338d","791":"21170ad0","838":"521c338d"}[chunkId] + ".css";
};